import { cents, formatCents } from '@sitzmark/core';
import type { FormatCentsOptions } from '@sitzmark/core';

/**
 * Format a money value that arrived over the wire.
 *
 * The API sends integer cents as a plain number, so the brand is lost in
 * transit. Re-establishing it here — rather than casting at each call site —
 * means the integer invariant is checked once, at the boundary, and a
 * malformed amount fails loudly instead of rendering as `$NaN` on a receipt.
 */
export function money(value: number, options?: FormatCentsOptions): string {
  return formatCents(cents(value), options);
}
